export const BLACKLIST = {
    'metadataMD5' : 1,
    'paleoData_paleoDataMD5' : 1,
    'paleoData_paleoMeasurementTableMD5' : 1,
    'paleoDataMD5' : 1,
    'paleoMeasurementTableMD5' : 1,
    'tagMD5' : 1,
    'chronData_chronDataMD5' : 1,
    'chronData_chronMeasurementTableMD5' : 1,
    'chronDataMD5' : 1,
    'chronMeasurementTableMD5' : 1
}

export const REVERSE_BLACKLIST = {
    'inferredFrom' : 1,
    'foundInTable' : 1,
    'foundInDataset' : 1
    //'takenAtDepth' : 1
}